// extracted by mini-css-extract-plugin
export var footer = "_q9-0";
export var inherit = "_q9-1";
export var input = "_q9-2";
export var modalContent = "_q9-3";
export var quillEditor = "_q9-4";
export var subtitle = "_q9-5";